// Product + collection page click tracking: one GA4 event per click on a link or control.
//   pdp_click        on product pages
//   collection_click on collection pages
// Same built-in link dimensions as `home_click`, so nothing needs registering in GA4 Admin:
//   link_classes = area (e.g. "gallery", "chips", "add_to_cart", "filters", "card_image")
//   link_url     = destination (links) or "" (buttons)
//   link_text    = product title or control text
//   link_id      = handle of the page the click happened on
// Only sends when the Google tag has loaded (it is consent-gated). Renders nothing.
(function () {
  var me = document.currentScript;
  var t = (me && me.getAttribute('data-template')) || '';
  var EVENT = t === 'product' ? 'pdp_click' : t === 'collection' ? 'collection_click' : null;
  if (!EVENT) return;
  var handle = (location.pathname.match(/\/(?:products|collections)\/([^/?#]+)/) || [])[1] || '';

  // First match wins, so put the more specific areas first.
  var PDP = [
    ['.quick-add-modal', 'quick_view'],
    ['.mini-card', 'sticky_add_to_cart'],
    ['.breadcrumb', 'breadcrumb'],
    ['.product__media-wrapper, media-gallery, .product__media-list, .thumbnail-list', 'gallery'],
    ['.pdpv2-rating, .jdgm-prev-badge, .rating-wrapper', 'rating_stars'],
    ['.pdpv2-chips, .pdpv2-facts', 'chips'],
    ['.quantity', 'quantity'],
    ['variant-selects, variant-radios, .js-product-option, .product-form__input', 'variant_picker'],
    ['.yc-mb', 'multibuy'],
    ['.shopify-payment-button', 'buy_now'],
    ['.product-form__submit, .product-form__buttons', 'add_to_cart'],
    ['#yc-eta, .yc-eta, .yc-ship-modal', 'delivery_date'],
    ['.yc-ask-link', 'ask_question'],
    ['.share-buttons', 'share'],
    ['.promo-code', 'promo_code'],
    ['klarna-placement, [class*="klarna"]', 'klarna'],
    ['.jdgm-cards-wrapper, .jdgm-carousel, .jdgm-cards-carousel, [id*="__17683548441ed43185"]', 'reviews_carousel'],
    ['.jdgm-rev-widg, .jdgm-review-widget', 'reviews'],
    ['.dropdown-under-review, .jdgm-all-reviews-text', 'reviews_link'],
    ['.music-block', 'music'],
    ['.aplus-section', 'aplus'],
    ['.video-accordion, .product-video-container', 'video'],
    ['.product__description, .product__description-block, .description-tags', 'description'],
    ['.jdgm-widget', 'reviews'],
    ['product-recommendations, .product-recommendations__outer', 'recommended'],
    ['.help-banner', 'help_banner'],
    ['.product__text', 'vendor'],
    ['.multicolumn', 'trust']
  ];
  var COLL = [
    ['.quick-add-modal', 'quick_view'],
    ['.card__quick-view, .quick-add', 'card_quick_view'],
    ['.card__add-to-cart', 'card_add_to_cart'],
    ['.yc-subcats', 'subcategories'],
    ['.yc-qbar', 'quick_filters'],
    ['.active-facets', 'filter_remove'],
    ['.yc-qbar__sel, .facets-sorting, .facet-sort-select, .mobile-facets__sort, .yc-sort, .products-grid__top-sorting', 'sort'],
    ['.products-grid__top, .mobile-facets, facet-filters-form, .facets, .facets-container, .yc-facets', 'filters'],
    ['.products-grid__tags, .products-grid__tag', 'tags'],
    ['.pagination', 'pagination'],
    ['load-more, .load-more, .button-wrapper', 'load_more'],
    ['.yc-swipe, .card .media', 'card_image'],
    ['.card__vendor', 'card_vendor'],
    ['.card__rating', 'card_rating'],
    ['.card-wrapper, .card, .collection-product-card', 'card_title'],
    ['.recently-viewed, [id*="__recently_viewed"]', 'recently_viewed'],
    ['.collection-hero, .banner, [id*="__banner"]', 'banner']
  ];
  var RULES = EVENT === 'pdp_click' ? PDP : COLL;
  var CONTROL = 'a[href], button, select, summary, label, input:not([type="hidden"]), [role="button"], [role="tab"], .jdgm-histogram__star';

  function area(el) {
    for (var i = 0; i < RULES.length; i++) if (el.closest(RULES[i][0])) return RULES[i][1];
    var s = el.closest('[id^="shopify-section-"]');
    return s ? 'other:' + s.id.split('__').pop() : null;
  }
  function text(el) {
    var card = el.closest('.card-wrapper, .collection-product-card, .mini-card') || el.closest('.card');
    var title = card && card.querySelector('.card__title, .card__heading, .mini-card__title, h3');
    var s = (title && title.textContent) || el.getAttribute('aria-label') || el.textContent || el.value || '';
    return String(s).replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  document.addEventListener('click', function (e) {
    if (typeof window.gtag !== 'function') return;
    var el = e.target.closest && e.target.closest(CONTROL);
    if (!el) return;
    // A click on a <label> also fires a synthetic click on its checkbox: count it once.
    if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio') && e.detail === 0 && el.closest('label')) return;
    if (!el.closest('main, .quick-add-modal, .mini-card')) return;
    var name = area(el);
    if (!name) return;
    try {
      window.gtag('event', EVENT, {
        link_classes: name,
        link_url: el.tagName === 'A' ? el.href : '',
        link_text: text(el),
        link_id: handle,
        transport_type: 'beacon'
      });
    } catch (err) {}
  }, true);
})();
